import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const PwaInstallTip = ({ open, onClose }) => {
    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden bg-[#1a1020]/38 p-3 sm:p-3 backdrop-blur-xl"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <div className="pointer-events-none absolute inset-0 overflow-hidden">
                        <div className="absolute -left-16 top-8 h-40 w-40 rounded-full bg-[#ff4da6]/18 blur-3xl" />
                        <div className="absolute -right-10 bottom-0 h-44 w-44 rounded-full bg-[#ff8fc8]/22 blur-3xl" />
                        <div className="absolute left-1/2 top-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/35 blur-3xl" />
                    </div>
                    <motion.div
                        role="dialog"
                        aria-labelledby="pwa-tip-title"
                        initial={{ y: 24, scale: 0.96, opacity: 0 }}
                        animate={{ y: 0, scale: 1, opacity: 1 }}
                        exit={{ y: 18, scale: 0.96, opacity: 0 }}
                        transition={{ type: 'spring', stiffness: 280, damping: 24 }}
                        className="relative 
                                        w-full 
                                        max-w-[360px] scrollbar-thin scrollbar-thumb-pink-300
                                        rounded-[28px] 
                                        border 
                                        border-[#ffb8d7] 
                                        bg-white 
                                        text-[#2f2230] 
                                        shadow-[0_24px_70px_rgba(255,77,166,0.22)]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="absolute inset-x-0 top-0 h-28 bg-[radial-gradient(circle_at_top,_rgba(255,77,166,0.22),_rgba(255,255,255,0)_72%)]" />
                        <div className="absolute inset-x-0 bottom-0 h-24 bg-[linear-gradient(180deg,rgba(255,255,255,0),rgba(255,240,247,0.9))]" />

                        <div className="relative p-3 sm:p-3">
                            <div className="mb-3 flex items-start justify-between gap-3">
                                <div>
                                    <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-[#ffb8d7] bg-[#fff4f9] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#ff4da6]">
                                        Install TLK
                                    </div>
                                    <h2 id="pwa-tip-title" className="text-[26px] font-semibold leading-tight text-[#22161f]">
                                        Put TLK right on your home screen
                                    </h2>
                                    <p className="mt-2 text-sm leading-relaxed text-[#6d5566]">
                                        Open chats faster, keep the experience app-like, and come back in one tap.
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#ffd5e7] bg-[#fff7fa] text-lg text-[#ff4da6] transition-colors hover:bg-[#ffeef6]"
                                    aria-label="Close install tip"
                                >
                                    x
                                </button>
                            </div>

                            <div className="mb-1 rounded-[24px] border border-[#ffd5e7] bg-[linear-gradient(135deg,#fff6fa,#fff)] p-3 shadow-[inset_0_1px_0_rgba(255,255,255,0.8)]">
                                <div className="flex items-center gap-2">
                                    <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#ff4da6] text-xl text-white shadow-[0_12px_24px_rgba(255,77,166,0.28)]">
                                        +
                                    </div>
                                    <div>
                                        <div className="text-sm font-semibold text-[#2c1e28]">Install in under 10 seconds</div>
                                        <div className="text-xs leading-relaxed text-[#8a7081]">
                                            Follow the steps for your device below.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="space-y-2">
                                <div className="rounded-[22px] border border-[#ffe0ec] bg-[#fff8fb] p-3">
                                    <div className="mb-2 flex items-center gap-3">

                                        <div>
                                            <div className="text-sm font-semibold text-[#2b1e28]">iPhone / iPad</div>
                                            <div className="text-xs text-[#957a8b]">Safari install flow</div>
                                        </div>
                                    </div>
                                    <p className="text-sm leading-relaxed text-[#715868]">
                                        Tap <span className="font-semibold text-[#ff4da6]">Share</span>, then choose <span className="font-semibold text-[#ff4da6]">&quot;Add to Home Screen&quot;</span>.
                                    </p>
                                </div>

                                <div className="rounded-[22px] border border-[#ffe0ec] bg-[#fff8fb] p-3">
                                    <div className="mb-2 flex items-center gap-3">

                                        <div>
                                            <div className="text-sm font-semibold text-[#2b1e28]">Android</div>
                                            <div className="text-xs text-[#957a8b]">Chrome or browser menu</div>
                                        </div>
                                    </div>
                                    <p className="text-sm leading-relaxed text-[#715868]">
                                        Open the browser menu, then tap <span className="font-semibold text-[#ff4da6]">&quot;Install app&quot;</span> or <span className="font-semibold text-[#ff4da6]">&quot;Add to Home screen&quot;</span>.
                                    </p>
                                </div>
                            </div>
                            <div className="mt-5 flex flex-col gap-3 sm:flex-row">
                                <button
                                    className="flex-1 rounded-full border border-[#ffd5e7] bg-white px-3 py-2 text-sm text-[#8a6478]"
                                    onClick={() => onClose()}
                                >
                                    Maybe later
                                </button>

                                <button
                                    className="flex-1 rounded-full bg-[#ff4da6] px-3 py-2 text-sm font-semibold text-white"
                                    onClick={() => onClose()}
                                >
                                    Got it
                                </button>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default PwaInstallTip;
